/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeKnownVillagerListResponse,
  ApiEnvelopeVillagerHallListResponse,
  ApiEnvelopeVillagerTradingCreatedResponse,
  ApiEnvelopeVillagerTradingEmptyResponse,
  ApiEnvelopeVillagerTradingRunResponse,
  RunVillagerTradingRequest,
  VillagerHallInputDto,
  VillagerTradeConfigInputDto,
  VillagerTradingStopVillagerTradingParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type villagerTradingGetVillagerHallsResponse200 = {
  data: ApiEnvelopeVillagerHallListResponse
  status: 200
}

export type villagerTradingGetVillagerHallsResponseSuccess = (villagerTradingGetVillagerHallsResponse200) & {
  headers: Headers;
};
;

export type villagerTradingGetVillagerHallsResponse = (villagerTradingGetVillagerHallsResponseSuccess)

export const getVillagerTradingGetVillagerHallsUrl = () => {




  return `/api/villagertrading/halls`
}

export const useVillagerTradingGetVillagerHallsHook = (): ( options?: RequestInit) => Promise<villagerTradingGetVillagerHallsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVillagerTradingGetVillagerHallsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type villagerTradingCreateVillagerHallResponse200 = {
  data: ApiEnvelopeVillagerTradingCreatedResponse
  status: 200
}

export type villagerTradingCreateVillagerHallResponseSuccess = (villagerTradingCreateVillagerHallResponse200) & {
  headers: Headers;
};
;

export type villagerTradingCreateVillagerHallResponse = (villagerTradingCreateVillagerHallResponseSuccess)

export const getVillagerTradingCreateVillagerHallUrl = () => {




  return `/api/villagertrading/halls`
}

export const useVillagerTradingCreateVillagerHallHook = (): (villagerHallInputDto?: VillagerHallInputDto, options?: RequestInit) => Promise<villagerTradingCreateVillagerHallResponse> => {

      const customFetcher = useSfetchMutator();
      return (villagerHallInputDto?: VillagerHallInputDto, options?: RequestInit) => {

        return customFetcher(getVillagerTradingCreateVillagerHallUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(villagerHallInputDto)
  }
);
      }
  }


export type villagerTradingGetHallVillagersResponse200 = {
  data: ApiEnvelopeKnownVillagerListResponse
  status: 200
}

export type villagerTradingGetHallVillagersResponse404 = {
  data: ApiEnvelopeKnownVillagerListResponse
  status: 404
}

export type villagerTradingGetHallVillagersResponseSuccess = (villagerTradingGetHallVillagersResponse200) & {
  headers: Headers;
};
export type villagerTradingGetHallVillagersResponseError = (villagerTradingGetHallVillagersResponse404) & {
  headers: Headers;
};

export type villagerTradingGetHallVillagersResponse = (villagerTradingGetHallVillagersResponseSuccess | villagerTradingGetHallVillagersResponseError)

export const getVillagerTradingGetHallVillagersUrl = (id: string,) => {




  return `/api/villagertrading/halls/${id}/villagers`
}

export const useVillagerTradingGetHallVillagersHook = (): (id: string, options?: RequestInit) => Promise<villagerTradingGetHallVillagersResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getVillagerTradingGetHallVillagersUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type villagerTradingUpdateVillagerHallResponse200 = {
  data: ApiEnvelopeVillagerTradingEmptyResponse
  status: 200
}

export type villagerTradingUpdateVillagerHallResponse404 = {
  data: ApiEnvelopeVillagerTradingEmptyResponse
  status: 404
}

export type villagerTradingUpdateVillagerHallResponseSuccess = (villagerTradingUpdateVillagerHallResponse200) & {
  headers: Headers;
};
export type villagerTradingUpdateVillagerHallResponseError = (villagerTradingUpdateVillagerHallResponse404) & {
  headers: Headers;
};

export type villagerTradingUpdateVillagerHallResponse = (villagerTradingUpdateVillagerHallResponseSuccess | villagerTradingUpdateVillagerHallResponseError)

export const getVillagerTradingUpdateVillagerHallUrl = (id: string,) => {




  return `/api/villagertrading/halls/${id}`
}

export const useVillagerTradingUpdateVillagerHallHook = (): (id: string,
    villagerHallInputDto?: VillagerHallInputDto, options?: RequestInit) => Promise<villagerTradingUpdateVillagerHallResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    villagerHallInputDto?: VillagerHallInputDto, options?: RequestInit) => {

        return customFetcher(getVillagerTradingUpdateVillagerHallUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(villagerHallInputDto)
  }
);
      }
  }


export type villagerTradingDeleteVillagerHallResponse200 = {
  data: ApiEnvelopeVillagerTradingEmptyResponse
  status: 200
}

export type villagerTradingDeleteVillagerHallResponse404 = {
  data: ApiEnvelopeVillagerTradingEmptyResponse
  status: 404
}

export type villagerTradingDeleteVillagerHallResponseSuccess = (villagerTradingDeleteVillagerHallResponse200) & {
  headers: Headers;
};
export type villagerTradingDeleteVillagerHallResponseError = (villagerTradingDeleteVillagerHallResponse404) & {
  headers: Headers;
};

export type villagerTradingDeleteVillagerHallResponse = (villagerTradingDeleteVillagerHallResponseSuccess | villagerTradingDeleteVillagerHallResponseError)

export const getVillagerTradingDeleteVillagerHallUrl = (id: string,) => {




  return `/api/villagertrading/halls/${id}`
}

export const useVillagerTradingDeleteVillagerHallHook = (): (id: string, options?: RequestInit) => Promise<villagerTradingDeleteVillagerHallResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getVillagerTradingDeleteVillagerHallUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type villagerTradingScanVillagerHallResponse200 = {
  data: ApiEnvelopeVillagerTradingRunResponse
  status: 200
}

export type villagerTradingScanVillagerHallResponse400 = {
  data: ApiEnvelopeVillagerTradingRunResponse
  status: 400
}

export type villagerTradingScanVillagerHallResponse404 = {
  data: ApiEnvelopeVillagerTradingRunResponse
  status: 404
}

export type villagerTradingScanVillagerHallResponseSuccess = (villagerTradingScanVillagerHallResponse200) & {
  headers: Headers;
};
export type villagerTradingScanVillagerHallResponseError = (villagerTradingScanVillagerHallResponse400 | villagerTradingScanVillagerHallResponse404) & {
  headers: Headers;
};

export type villagerTradingScanVillagerHallResponse = (villagerTradingScanVillagerHallResponseSuccess | villagerTradingScanVillagerHallResponseError)

export const getVillagerTradingScanVillagerHallUrl = (id: string,) => {




  return `/api/villagertrading/halls/${id}/scan`
}

export const useVillagerTradingScanVillagerHallHook = (): (id: string,
    runVillagerTradingRequest?: RunVillagerTradingRequest, options?: RequestInit) => Promise<villagerTradingScanVillagerHallResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runVillagerTradingRequest?: RunVillagerTradingRequest, options?: RequestInit) => {

        return customFetcher(getVillagerTradingScanVillagerHallUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runVillagerTradingRequest)
  }
);
      }
  }


export type villagerTradingCreateVillagerTradeConfigResponse200 = {
  data: ApiEnvelopeVillagerTradingCreatedResponse
  status: 200
}

export type villagerTradingCreateVillagerTradeConfigResponse400 = {
  data: ApiEnvelopeVillagerTradingCreatedResponse
  status: 400
}

export type villagerTradingCreateVillagerTradeConfigResponse404 = {
  data: ApiEnvelopeVillagerTradingCreatedResponse
  status: 404
}

export type villagerTradingCreateVillagerTradeConfigResponseSuccess = (villagerTradingCreateVillagerTradeConfigResponse200) & {
  headers: Headers;
};
export type villagerTradingCreateVillagerTradeConfigResponseError = (villagerTradingCreateVillagerTradeConfigResponse400 | villagerTradingCreateVillagerTradeConfigResponse404) & {
  headers: Headers;
};

export type villagerTradingCreateVillagerTradeConfigResponse = (villagerTradingCreateVillagerTradeConfigResponseSuccess | villagerTradingCreateVillagerTradeConfigResponseError)

export const getVillagerTradingCreateVillagerTradeConfigUrl = () => {




  return `/api/villagertrading/trade`
}

export const useVillagerTradingCreateVillagerTradeConfigHook = (): (villagerTradeConfigInputDto?: VillagerTradeConfigInputDto, options?: RequestInit) => Promise<villagerTradingCreateVillagerTradeConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (villagerTradeConfigInputDto?: VillagerTradeConfigInputDto, options?: RequestInit) => {

        return customFetcher(getVillagerTradingCreateVillagerTradeConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(villagerTradeConfigInputDto)
  }
);
      }
  }


export type villagerTradingUpdateVillagerTradeConfigResponse200 = {
  data: ApiEnvelopeVillagerTradingEmptyResponse
  status: 200
}

export type villagerTradingUpdateVillagerTradeConfigResponse400 = {
  data: ApiEnvelopeVillagerTradingEmptyResponse
  status: 400
}

export type villagerTradingUpdateVillagerTradeConfigResponse404 = {
  data: ApiEnvelopeVillagerTradingEmptyResponse
  status: 404
}

export type villagerTradingUpdateVillagerTradeConfigResponseSuccess = (villagerTradingUpdateVillagerTradeConfigResponse200) & {
  headers: Headers;
};
export type villagerTradingUpdateVillagerTradeConfigResponseError = (villagerTradingUpdateVillagerTradeConfigResponse400 | villagerTradingUpdateVillagerTradeConfigResponse404) & {
  headers: Headers;
};

export type villagerTradingUpdateVillagerTradeConfigResponse = (villagerTradingUpdateVillagerTradeConfigResponseSuccess | villagerTradingUpdateVillagerTradeConfigResponseError)

export const getVillagerTradingUpdateVillagerTradeConfigUrl = (id: string,) => {




  return `/api/villagertrading/trade/${id}`
}

export const useVillagerTradingUpdateVillagerTradeConfigHook = (): (id: string,
    villagerTradeConfigInputDto?: VillagerTradeConfigInputDto, options?: RequestInit) => Promise<villagerTradingUpdateVillagerTradeConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    villagerTradeConfigInputDto?: VillagerTradeConfigInputDto, options?: RequestInit) => {

        return customFetcher(getVillagerTradingUpdateVillagerTradeConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(villagerTradeConfigInputDto)
  }
);
      }
  }


export type villagerTradingDeleteVillagerTradeConfigResponse200 = {
  data: ApiEnvelopeVillagerTradingEmptyResponse
  status: 200
}

export type villagerTradingDeleteVillagerTradeConfigResponse404 = {
  data: ApiEnvelopeVillagerTradingEmptyResponse
  status: 404
}

export type villagerTradingDeleteVillagerTradeConfigResponseSuccess = (villagerTradingDeleteVillagerTradeConfigResponse200) & {
  headers: Headers;
};
export type villagerTradingDeleteVillagerTradeConfigResponseError = (villagerTradingDeleteVillagerTradeConfigResponse404) & {
  headers: Headers;
};

export type villagerTradingDeleteVillagerTradeConfigResponse = (villagerTradingDeleteVillagerTradeConfigResponseSuccess | villagerTradingDeleteVillagerTradeConfigResponseError)

export const getVillagerTradingDeleteVillagerTradeConfigUrl = (id: string,) => {




  return `/api/villagertrading/trade/${id}`
}

export const useVillagerTradingDeleteVillagerTradeConfigHook = (): (id: string, options?: RequestInit) => Promise<villagerTradingDeleteVillagerTradeConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getVillagerTradingDeleteVillagerTradeConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type villagerTradingRunVillagerTradeConfigResponse200 = {
  data: ApiEnvelopeVillagerTradingRunResponse
  status: 200
}

export type villagerTradingRunVillagerTradeConfigResponse400 = {
  data: ApiEnvelopeVillagerTradingRunResponse
  status: 400
}

export type villagerTradingRunVillagerTradeConfigResponse404 = {
  data: ApiEnvelopeVillagerTradingRunResponse
  status: 404
}

export type villagerTradingRunVillagerTradeConfigResponseSuccess = (villagerTradingRunVillagerTradeConfigResponse200) & {
  headers: Headers;
};
export type villagerTradingRunVillagerTradeConfigResponseError = (villagerTradingRunVillagerTradeConfigResponse400 | villagerTradingRunVillagerTradeConfigResponse404) & {
  headers: Headers;
};

export type villagerTradingRunVillagerTradeConfigResponse = (villagerTradingRunVillagerTradeConfigResponseSuccess | villagerTradingRunVillagerTradeConfigResponseError)

export const getVillagerTradingRunVillagerTradeConfigUrl = (id: string,) => {




  return `/api/villagertrading/trade/${id}/run`
}

export const useVillagerTradingRunVillagerTradeConfigHook = (): (id: string,
    runVillagerTradingRequest?: RunVillagerTradingRequest, options?: RequestInit) => Promise<villagerTradingRunVillagerTradeConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runVillagerTradingRequest?: RunVillagerTradingRequest, options?: RequestInit) => {

        return customFetcher(getVillagerTradingRunVillagerTradeConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runVillagerTradingRequest)
  }
);
      }
  }


export type villagerTradingStopVillagerTradingResponse200 = {
  data: ApiEnvelopeVillagerTradingEmptyResponse
  status: 200
}

export type villagerTradingStopVillagerTradingResponse404 = {
  data: ApiEnvelopeVillagerTradingEmptyResponse
  status: 404
}

export type villagerTradingStopVillagerTradingResponseSuccess = (villagerTradingStopVillagerTradingResponse200) & {
  headers: Headers;
};
export type villagerTradingStopVillagerTradingResponseError = (villagerTradingStopVillagerTradingResponse404) & {
  headers: Headers;
};

export type villagerTradingStopVillagerTradingResponse = (villagerTradingStopVillagerTradingResponseSuccess | villagerTradingStopVillagerTradingResponseError)

export const getVillagerTradingStopVillagerTradingUrl = (params?: VillagerTradingStopVillagerTradingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/villagertrading/stop?${stringifiedParams}` : `/api/villagertrading/stop`
}

export const useVillagerTradingStopVillagerTradingHook = (): (params?: VillagerTradingStopVillagerTradingParams, options?: RequestInit) => Promise<villagerTradingStopVillagerTradingResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: VillagerTradingStopVillagerTradingParams, options?: RequestInit) => {

        return customFetcher(getVillagerTradingStopVillagerTradingUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


